import { render, staticRenderFns } from "./ListadoRDIMobile.vue?vue&type=template&id=766f61f8&scoped=true"
import script from "./ListadoRDIMobile.vue?vue&type=script&lang=js"
export * from "./ListadoRDIMobile.vue?vue&type=script&lang=js"
import style0 from "./ListadoRDIMobile.vue?vue&type=style&index=0&id=766f61f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f61f8",
  null
  
)

export default component.exports